import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Paneel from "../../doors/paneel";
import Schuif from "../../doors/schuif";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface SinglePanelSingleSchuifProps extends ConfigurationProps {}
const SinglePanelSingleSchuif: React.FC<SinglePanelSingleSchuifProps> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: SinglePanelSingleSchuifProps) => {
  const position0 = new Vector3(-0.459, 0, 0);
  const position1 = new Vector3(0.459, 0, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(getConfigurationPositions([position0, position1]));
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <Paneel
        materials={materials}
        position={positions[0]}
        index={0}
        rotateNewlayouts={true}
      />
      <Schuif
        materials={materials}
        position={positions[1]}
        index={1}
        rotation={rotation}
        rotateNewlayouts={true}
        frameSettings={doorSettings?.main?.frameSettings}
        railSettings={doorSettings?.main?.railSettings}
      />
    </group>
  );
};

export default SinglePanelSingleSchuif;
